import { defu } from 'defu';

export const useFetchAPI = (url: string, userOptions = {}) => {
  const config = useRuntimeConfig();
  const defaultOptions = {
    baseURL: config.public.ApiBaseUrl,
    method: 'GET',
    headers: {
      Accept: 'application/json'
    },
    credentials: 'include'
  };
  const options = defu(userOptions, defaultOptions);
  //@ts-ignore
  return $fetch(url, options);
};
